import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, MenuItem, Select, Typography } from '@mui/material';
import { BackdropLoader, SimpleModal } from '@livable/saas-react-components';
import { COUPON_EDITABLE_STATUSES, COUPON_STATUS, getCouponStatusTagSx } from '../couponsModel';
import { CouponModalContent } from './content';
import useStyles from './styles';
export const CouponModal = _ref => {
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    mode = _ref.mode,
    coupon = _ref.coupon,
    _ref$coupons = _ref.coupons,
    coupons = _ref$coupons === void 0 ? [] : _ref$coupons,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting,
    onSave = _ref.onSave;
  const classes = useStyles();
  const contentRef = useRef(null);
  const isEdit = mode === 'edit';
  const _useState = useState(COUPON_STATUS.ACTIVE),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  useEffect(() => {
    if (!isOpen) return;
    const stored = isEdit ? coupon === null || coupon === void 0 ? void 0 : coupon.status : null;
    setStatus(stored === COUPON_STATUS.DRAFT ? COUPON_STATUS.DRAFT : COUPON_STATUS.ACTIVE);
  }, [isOpen, isEdit, coupon]);

  /** The backend rejects duplicates too; this catches them before the round trip. */
  const existingCodes = coupons.filter(c => c.id !== (coupon === null || coupon === void 0 ? void 0 : coupon.id)).map(c => {
    var _c$code;
    return ((_c$code = c.code) !== null && _c$code !== void 0 ? _c$code : '').toUpperCase();
  }).filter(Boolean);
  const handleSubmit = async () => {
    var _contentRef$current;
    if (!((_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.validate())) return;
    const saved = await (onSave === null || onSave === void 0 ? void 0 : onSave(_objectSpread(_objectSpread({}, contentRef.current.getPayload()), {}, {
      status
    })));
    if (saved !== false) onClose();
  };
  const submitLabel = isEdit ? 'Save coupon' : status === COUPON_STATUS.DRAFT ? 'Save draft' : 'Activate coupon';
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: null,
    isOpen: isOpen,
    handleClose: onClose,
    title: /*#__PURE__*/React.createElement(Box, {
      component: "span",
      className: classes.titleRow
    }, isEdit ? 'Edit coupon' : 'Add coupon', /*#__PURE__*/React.createElement(Select, {
      value: status,
      onChange: e => setStatus(e.target.value),
      variant: "standard",
      disableUnderline: true,
      className: classes.statusSelect,
      sx: getCouponStatusTagSx(status),
      renderValue: value => /*#__PURE__*/React.createElement(Typography, {
        component: "span",
        className: classes.statusValue
      }, value)
    }, COUPON_EDITABLE_STATUSES.map(value => /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: value
    }, value)))),
    leftButton: /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      onClick: onClose,
      disabled: isSubmitting
    }, "Cancel"),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: handleSubmit,
      disabled: isSubmitting
    }, isSubmitting ? 'Saving...' : submitLabel)
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isSubmitting
  }), /*#__PURE__*/React.createElement(CouponModalContent, {
    ref: contentRef,
    isOpen: isOpen,
    isEdit: isEdit,
    coupon: coupon,
    existingCodes: existingCodes,
    products: products
  }));
};